const meaulist = [
  {
    menuName: "概况",
    url: "/home/workSpace",
    // children: [
    //   {
    //     menuName: "数据概况",
    //     url: "/home/workSpace",
    //     icon: "icon-gaikuang",
    //   }
    // ]
  },
  {
    menuName: "小程序",
    url: "/home/applet",
    children: [
      {
        menuName: "名片管理",
        url: "/home/applet/card",
        icon: "icon-mingpianguanli",
        children: [
          {
            menuName: "名片管理",
            url: "/home/applet/card/cardlist",
          },
          {
            menuName: "企业标签设置",
            url: "/home/applet/card/cardTags",
          },
          {
            menuName: "名片模块",
            url: "/home/applet/card/cardTitle",
          },
        ],
      },
      {
        menuName: "动态管理",
        icon: "icon-dongtaiguanli",
        url: "/home/applet/moments",
        children: [
          {
            menuName: "动态管理",
            url: "/home/applet/moments/listPannel",
          },
          {
            menuName: "草稿箱",
            url: "/home/applet/moments/draftBoxPannel",
          },
          // {
          //   menuName: "评论管理",
          //   url: "/home/applet/moments/commentsPannel",
          // },
          {
            menuName: "栏目管理",
            url: "/home/applet/moments/columnPannel",
          },
          {
            menuName: "动态设置",
            url: "/home/applet/moments/setPannel",
          },
        ],
      },
      {
        menuName: "官网装修",
        icon: "icon-guanwangzhuangxiu",
        url: "/home/applet/appletDesign",
      },
      {
        menuName: "小程序配置",
        url: "/home/applet/appletsettings",
        icon: "icon-xiaochengxupeizhi",
        children: [
          {
            menuName: "话术库",
            url: "/home/applet/appletsettings/SettinsSpeech",
          },
          {
            menuName: "聊天设置",
            url: "/home/applet/appletsettings/SettingsChat",
          },
          {
            menuName: "底部导航",
            url: "/home/applet/appletsettings/SettingsBottomNav",
          },
          {
            menuName: "知识库配置",
            url: "/home/applet/appletsettings/SettingsKnowledge",
          },
        ],
      },
      {
        menuName: "推广路径",
        icon: "icon-tuiguanglujing",
        url: "/home/applet/extension",
        children: [
          {
            menuName: "小程序界面",
            url: "/home/applet/extension/extensionSmall",
          },
          {
            menuName: "商品",
            url: "/home/applet/extension/extensionGoods",
          },
        ],
      },
    ],
  },
  {
    menuName: "商城",
    url: "/home/shopmall",
    children: [
      {
        menuName: "商城配置",
        icon: "icon-shangchengpeizhi",
        url: "/home/shopmall/shopmallsettings",
        children: [
          {
            menuName: "基础设置",
            url: "/home/shopmall/shopmallsettings/basicSettings",
          },
          {
            menuName: "售后设置",
            url: "/home/shopmall/shopmallsettings/aftersalesSettings",
          },
          {
            menuName: "线下提成设置",
            url: "/home/shopmall/shopmallsettings/offlineCommissionSetting",
          },
          {
            menuName: "购物车按钮配置",
            url: "/home/shopmall/shopmallsettings/shoppingCartSetting",
          },
          {
            menuName: "商城标签",
            url: "/home/shopmall/shopmallsettings/goodsTags",
          },
          {
            menuName: "商城公告",
            url: "/home/shopmall/shopmallsettings/goodsNotice",
          },
          {
            menuName: "订单设置",
            url: "/home/shopmall/shopmallsettings/orderSettings",
          },
        ],
      },
      {
        menuName: "商品管理",
        icon: "icon-shangpinguanli",
        url: "/home/shopmall/goods",
        children: [
          {
            menuName: "商品列表",
            url: "/home/shopmall/goods/goodsList",
          },
          // {
          //   menuName: "定制规格",
          //   url: "/home/shopmall/goods/customSpecifications",
          // },
          {
            menuName: "商品分类",
            url: "/home/shopmall/goods/goodsCategories",
          },
          // {
          //   menuName: "商品规格",
          //   url: "/home/shopmall/goods/goodsSpecifications",
          // }
        ],
      },
      {
        menuName: "积分商城",
        icon: "icon-jifenshangcheng",
        url: "/home/shopmall/integral",
        children: [
          {
            menuName: "商品列表",
            url: "/home/shopmall/integral/integralList",
          },
          {
            menuName: "商品分类",
            url: "/home/shopmall/integral/integralCategories",
          },
          {
            menuName: "商品规格",
            url: "/home/shopmall/integral/integralSpecifications",
          },
          {
            menuName: "签到",
            url: "/home/shopmall/integral/integralSignin",
          },
          {
            menuName: "积分明细",
            url: "/home/shopmall/integral/integralDetail",
          },
        ],
      },

      // {
      //   menuName: "商城页面装修",
      //   icon: "icon-shangchengyemianzhuangxiu",
      //   url: "/home/shopmall/decoration",
      //   children:[
      //     {
      //       menuName: "商城首页",
      //       url: "/home/shopmall/decoration/homeDecoration",
      //     },
      //     {
      //       menuName: "商品详情页",
      //       url: "/home/shopmall/decoration/detailsDecoration",
      //     }
      //   ]
      // },
      {
        menuName: "订单售后",
        icon: "icon-dingdanshouhou",
        url: "/home/shopmall/order",
        children: [
          {
            menuName: "订单管理",
            url: "/home/shopmall/order/orderManagementList",
          },
          {
            menuName: "售后管理",
            url: "/home/shopmall/order/aftersalesManagementList",
          },
          // {
          //   menuName: "员工订单",
          //   url: "/home/shopmall/order/employeeOrderList",
          // }
          {
            menuName: "定制订单",
            url: "/home/shopmall/order/customOrderList",
          },
        ],
      },
      {
        menuName: "特权折扣",
        icon: "icon-tequanzhekou",
        url: "/home/shopmall/discount",
        children: [
          // {
          //   menuName: "员工特权",
          //   url: "/home/shopmall/discount/employeePrivilege",
          // },
          {
            menuName: "特权优惠券",
            url: "/home/shopmall/discount/privilegeCoupon",
          },
          {
            menuName: "核销代金券（线下）",
            url: "/home/shopmall/discount/writeOffVoucher",
          },
        ],
      },
      {
        menuName: "运费管理",
        icon: "icon-caozuo-mianyunfei",
        url: "/home/shopmall/freightmanage",
        children: [
          {
            menuName: "运费模板",
            url: "/home/shopmall/freightmanage/freightTemplateList",
          },
          {
            menuName: "包邮设置",
            url: "/home/shopmall/freightmanage/shippingSettings",
          },
        ],
      },
    ],
  },

  {
    menuName: "营销",
    url: "/home/analytics",
    children: [
      {
        menuName: "宣传册",
        icon: "icon-xuanchuance",
        url: "/home/analytics/brochure",
      },
      {
        menuName: "表单",
        icon: "icon-biaodanzujian-biaoge",
        url: "/home/analytics/form",
        children: [
          {
            menuName: "营销表单",
            url: "/home/analytics/form/yingxiaoform",
          },
          {
            menuName: "预约表单",
            url: "/home/analytics/form/yuyueform",
          },
        ],
      },
      {
        menuName: "分销",
        icon: "icon-fenxiao",
        url: "/home/analytics/distribution",
      },
      {
        menuName: "获客文章",
        icon: "icon-huokewenzhang",
        url: "/home/analytics/material",
        children: [
          {
            menuName: "文章列表",
            url: "/home/analytics/material/MaterialArticle",
          },
        ],
      },
      {
        menuName: "公众号设置",
        icon: "icon-gongzhonghaoshezhi",
        url: "/home/analytics/official",
        children: [
          {
            menuName: "引导关注",
            url: "/home/analytics/official/analyticsOfficialFocus",
          },
          {
            menuName: "关键词自动回复",
            url: "/home/analytics/official/analyticsOfficialReplyWord",
          },
          {
            menuName: "被关注自动回复",
            url: "/home/analytics/official/analyticsOfficialReplyAfterFocus",
          },
          {
            menuName: "公众号二维码",
            url: "/home/analytics/official/analyticsOfficialQrcode",
          },
        ],
      },
      {
        menuName: "任务商机",
        icon: "icon-renwushangji",
        url: "/home/analytics/opportunity",
        children: [
          {
            menuName: "商机设置",
            url: "/home/analytics/opportunity/AnalyticsOpportunityBusiness",
          },
        ],
      },
      {
        menuName: "视频",
        icon: "icon-shipin",
        url: "/home/analytics/marketVideo",
      },
      {
        menuName: "企业相册",
        icon: "icon-xiangce",
        url: "/home/analytics/album",
      },
      {
        menuName: "相册分类",
        icon: "icon-xiangce",
        url: "/home/analytics/classify",
      },
    ],
  },
  {
    menuName: "合伙人系统",
    url: "/home/partner",
    children: [
      {
        menuName: "汇总分析",
        icon: "icon-huizongfenxi",
        url: "/home/partner/summary",
      },
      {
        menuName: "分红方案",
        icon: "icon-fenhongfangan",
        url: "/home/partner/scheme",
      },
      {
        menuName: "项目毛利率",
        icon: "icon-daikuanlishuaizhuanhuan",
        url: "/home/partner/profit",
      },
      {
        menuName: "添加合伙人",
        icon: "icon-tianjiahehuoren",
        url: "/home/partner/add",
        children: [
          {
            menuName: "内部合伙人",
            url: "/home/partner/add/internalPartner",
          },
          {
            menuName: "外部合伙人",
            url: "/home/partner/add/externalPartner",
          },
        ],
      },
      {
        menuName: "购买订单",
        icon: "icon-goumaidingdan",
        url: "/home/partner/buy",
      },
      {
        menuName: "客源记录",
        icon: "icon-keyuanjilu",
        url: "/home/partner/customerRecord",
      },
      {
        menuName: "入股记录",
        icon: "icon-rugujilu",
        url: "/home/partner/rugu",
      },
    ],
  },
  {
    menuName: "活动拓客",
    url: "/home/tuoke",
    children: [
      {
        menuName: "活动数据",
        icon: "icon-huodongshuju",
        url: "/home/tuoke/tkWorkSpace",
      },
      {
        menuName: "活动管理",
        icon: "icon-huodongguanli",
        url: "/home/tuoke/tkAnalytics",
        children: [
          {
            menuName: "我的活动",
            url: "/home/tuoke/tkAnalytics",
          },
          {
            menuName: "创建活动",
            url: "/home/tuoke/templateList",
          },
        ],
      },
      {
        menuName: "日志管理",
        icon: "icon-rizhiguanli",
        url: "/home/tuoke/tkJournal",
        children: [
          {
            menuName: "购买日志",
            url: "/home/tuoke/tkJournal/purchaselog",
          },
          {
            menuName: "访问日志",
            url: "/home/tuoke/tkJournal/participationlog",
          },
          {
            menuName: "分享日志",
            url: "/home/tuoke/tkJournal/sharelogin",
          },
          {
            menuName: "抽奖日志",
            url: "/home/tuoke/tkJournal/drawLog",
          },
          {
            menuName: "抖音日志",
            url: "/home/tuoke/tkJournal/dyLog",
          },
        ],
      },
      {
        menuName: "资金管理",
        icon: "icon-zijinguanli",
        url: "/home/tuoke/tkFundManage",
        children: [
          // {
          //   menuName: "申请提现",
          //   url: "/home/tuoke/tkFundManage/accountWdrawal",
          // },
          // {
          //   menuName: "提现记录",
          //   url: "/home/tuoke/tkFundManage/accountWdrawalList",
          // },
          {
            menuName: "资金流水",
            url: "/home/tuoke/tkFundManage/capitalFlow",
          },
        ],
      },
      {
        menuName: "分销员认证",
        icon: "icon-fenxiaoyuanrenzheng",
        url: "/home/tuoke/tkShenhe",
      },
      {
        menuName: "联盟商家",
        icon: "icon-lianmengshangjia",
        url: "/home/tuoke/tkMerchant",
      },
    ],
  },
  {
    menuName: "客户",
    url: "/home/customer",
    children: [
      {
        menuName: "客户列表",
        icon: "icon-kehuliebiao",
        url: "/home/customer",
        children: [
          {
            menuName: "客户列表",
            url: "/home/customer/customerList",
          },
          {
            menuName: "访客列表",
            url: "/home/customer/visitorList",
          },
        ],
      },
      {
        menuName: "标签管理",
        icon: "icon-biaoqianguanli",
        url: "/home/customerLebel",
      },
    ],
  },

  {
    menuName: "员工",
    url: "/home/employee",
    children: [
      {
        menuName: "员工管理",
        icon: "icon-yuangongguanli",
        url: "/home/employee/manage",
      },
      {
        menuName: "角色管理",
        icon: "icon-jiaoseguanli",
        url: "/home/employee/enployeemanage",
      },
      {
        menuName: "雷达权限管理",
        icon: "icon-leida",
        url: "/home/employee/roles",
      },
      {
        menuName: "工作交接",
        icon: "icon-gongzuojiaojie",
        url: "/home/employee/handover",
      },
      {
        menuName: "锁粉设置",
        icon: "icon-suofenshezhi",
        url: "/home/employee/lockguest",
      },
    ],
  },

  {
    menuName: "财务",
    url: "/home/finance",
    children: [
      {
        menuName: "佣金管理",
        icon: "icon-yongjinguanli",
        url: "/home/finance/commissions",
        children: [
          {
            menuName: "个人佣金",
            url: "/home/finance/commissions/personalCommission",
          },
          {
            menuName: "员工佣金",
            url: "/home/finance/commissions/employeeCommission",
          },
          {
            menuName: "提现审核",
            url: "/home/finance/commissions/withdrawalReview",
          },
          {
            menuName: "佣金设置",
            url: "/home/finance/commissions/commissionSetting",
          },
        ],
      },
      {
        menuName: "退款订单",
        icon: "icon-shouhoutuikuan",
        url: "/home/finance/refundOrder",
      },
    ],
  },

  {
    menuName: "设置",
    url: "/home/settings",
    children: [
      {
        menuName: "企业信息",
        icon: "icon-qiyexinxi",
        url: "/home/settings/enterprise",
      },
      {
        menuName: "授权管理",
        icon: "icon-shouquanguanli",
        url: "/home/settings/authorization",
        children: [
          {
            menuName: "名片小程序授权",
            url: "/home/settings/authorization/miniappPannel",
          },
          {
            menuName: "服务号授权",
            url: "/home/settings/authorization/articlePannel",
          },
          {
            menuName: "订阅消息配置",
            url: "/home/settings/authorization/subscribePannel",
          },
        ],
      },
      {
        menuName: "App启动页",
        icon: "icon-yingyongqidongye",
        url: "/home/settings/startUp",
      },
      // {
      //   menuName: "开放平台",
      // icon: "iconicon17",
      //   url: "/home/settings/openplatform"
      // },
      {
        menuName: "支付设置",
        icon: "icon-zhifushezhi",
        url: "/home/settings/payment",
      },
    ],
  },
  // {
  //   menuName: "意见反馈",
  //   url: "/home/feedback/feedbackList",
  //   children: []
  // }
];

// export default meaulist;
// export default homebottomlist;
export default {
  meaulist: meaulist,
};
